import React from 'react';
import { ProfileLayout } from '../components/ProfileLayout';
import { Notifications } from '../components/Notifications';

export const NotificationsPage = () => {
  return (
    <ProfileLayout activeTab="notifications">
      <Notifications />
    </ProfileLayout>
  );
};
